module.exports = __webpack_public_path__ + "media/images/company/company_01_sub-1aa7b9b34abb6dfe5e3b64d3f4d9f74f.jpg";